import type { PageLink } from '@/lib/pageOrder';

interface PageNavigationProps {
  prev: PageLink | null;
  next: PageLink | null;
  onNavigate: (path: string) => void;
}

export function PageNavigation({ prev, next, onNavigate }: PageNavigationProps) {
  if (!prev && !next) return null;

  return (
    <div className="page-nav">
      {prev ? (
        <button onClick={() => onNavigate(prev.path)} className="prev">
          <span className="nav-label">&larr; Previous</span>
          <span className="nav-title">{prev.title}</span>
        </button>
      ) : (
        <span />
      )}
      {next ? (
        <button onClick={() => onNavigate(next.path)} className="next">
          <span className="nav-label">Next &rarr;</span>
          <span className="nav-title">{next.title}</span>
        </button>
      ) : (
        <span />
      )}
    </div>
  );
}
